import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { AccountPasswordDialogComponent } from './components/account-password/account-password.component';
import { PasswordRulesCheckComponent } from './components/password-rules-check/password-rules-check.component';

@NgModule({
  declarations: [PasswordRulesCheckComponent, AccountPasswordDialogComponent],
  imports: [AppSharedModule],
  exports: [PasswordRulesCheckComponent, AccountPasswordDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountSharedModule {}
